export default "__VITE_ASSET__CfX1nJ2F__"